module.exports = "../images/hunting.jpg?v=edcbb0f";